import { _ as _inherits, a as _createSuper, b as _classCallCheck, c as _createClass } from './createClass-3115abc1.esm.js';
import { P as ProtocolCallUseCase } from './ProtocolCallUseCase-da9f73b0.esm.js';

var FollowPolicyType;
(function (FollowPolicyType) {
  FollowPolicyType["ONLY_PROFILE_OWNERS"] = "ONLY_PROFILE_OWNERS";
  FollowPolicyType["CHARGE"] = "CHARGE";
  FollowPolicyType["ANYONE"] = "ANYONE";
  FollowPolicyType["NO_ONE"] = "NO_ONE";
  FollowPolicyType["UNKNOWN"] = "UNKNOWN";
})(FollowPolicyType || (FollowPolicyType = {}));
var UpdateFollowPolicy = /*#__PURE__*/function (_ProtocolCallUseCase) {
  _inherits(UpdateFollowPolicy, _ProtocolCallUseCase);
  var _super = _createSuper(UpdateFollowPolicy);
  function UpdateFollowPolicy() {
    _classCallCheck(this, UpdateFollowPolicy);
    return _super.apply(this, arguments);
  }
  return _createClass(UpdateFollowPolicy);
}(ProtocolCallUseCase);

export { FollowPolicyType as F, UpdateFollowPolicy as U };
